export class TopKeyWordsFilter {
    classifiedBasedON: string;
    ticketType: string;
    startDate: string;
    endDate: string;
    domainOption: string;
    SupportGroupName: string[];
    responselen: number;
    BatchId: string;
    isSkipTopWords: boolean;
    DeliveryStructureAttribute: string;
    FilteredBy: string;
    FilterData: string;
    ExistingStopwords: string;
    ApplicationName: string;
    Language: string;
    constructor(BatchId,isSkipTopWords, startDate, endDate, responselen, domainOption, classifiedBasedON, ticketType, SupportGroupName, DeliveryStructureAttribute, filterBy, stopWords = '', ApplicationName,Language) {
        this.classifiedBasedON = classifiedBasedON;
        this.ticketType = ticketType;
        this.startDate = startDate;
        this.endDate = endDate;
        this.domainOption = domainOption;
        this.SupportGroupName = SupportGroupName;
        this.responselen = responselen;
        this.BatchId = BatchId;
        this.isSkipTopWords = isSkipTopWords;
        this.DeliveryStructureAttribute = DeliveryStructureAttribute;
        this.FilteredBy = filterBy,
        this.FilterData = SupportGroupName,
        this.ExistingStopwords = (stopWords == '' || stopWords == undefined || stopWords == null) ? '' : stopWords,
        this.ApplicationName = ApplicationName,
        this.Language = Language
    }
}
